/* eslint-disable react/no-danger */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/forbid-prop-types */
import PropTypes from "prop-types";
import Button from "@fdn/button";

const EmptyState = ({
	title,
	subtitle,
	imagePath,
	handleEmpty,
	buttonTitle,
	isPromoPage,
	flexDirection,
	justifyContent,
	widthImage,
	textAlign,
	buttonJustifyContent,
	gap,
	buttonBorderRadius,
}) => (
	<>
		<section className="err-section">
			<div className="err-image">
				<img src={imagePath} alt="no_promotion_available" />
			</div>
			<div className="post-wrapper-empty">
				<div className="empty-warning-wrapper">
					<h3 className="empty-warning-title">{title}</h3>
					<p
						className="empty-warning-subtitle"
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
					{buttonTitle ? (
						<div className="button-container">
							<Button
								is_loading
								id_element="add-cart"
								size="medium"
								variant="primary-bs"
								padding="0 25px"
								font_family="Creato Display"
								font_weight="500"
								on_click={handleEmpty}
								border_radius={buttonBorderRadius}
							>
								{buttonTitle}
							</Button>
						</div>
					) : (
						""
					)}
				</div>
			</div>
		</section>
		<style jsx>
			{`
				.err-section .err-image {
					display: flex;
					width: ${widthImage};
					justify-content: center;
				}
				.err-section {
					margin: 120px 0;
					${isPromoPage ? "margin: 50px 0 80px 0;" : ""}
					display: flex;
					flex-direction: ${flexDirection};
					justify-content: ${justifyContent};
					gap: ${gap};
				}
				.err-section .post-wrapper-empty {
					display: flex;
					justify-content: center;
				}
				.err-section .empty-warning-title {
					font-size: 20px;
					font-weight: 600;
					line-height: 28px;
					letter-spacing: 0.04em;
					text-align: ${textAlign};
					margin-bottom: 0;
				}
				.err-section .empty-warning-subtitle {
					font-size: 16px;
					font-weight: 400;
					line-height: 22px;
					letter-spacing: 0.04em;
					text-align: center;
					margin-bottom: 37px;
					color: #454f5b;
				}
				.err-section .button-container {
					display: flex;
					justify-content: ${buttonJustifyContent};
				}
			`}
		</style>
	</>
);

EmptyState.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	imagePath: PropTypes.string,
	handleEmpty: PropTypes.func,
	buttonTitle: PropTypes.string,
	isPromoPage: PropTypes.bool,
	flexDirection: PropTypes.string,
	justifyContent: PropTypes.string,
	widthImage: PropTypes.string,
	textAlign: PropTypes.string,
	buttonJustifyContent: PropTypes.string,
	gap: PropTypes.string,
	buttonBorderRadius: PropTypes.string,
};

EmptyState.defaultProps = {
	title: "Data not found",
	subtitle: "",
	imagePath: "/images/product_not_available.png",
	handleEmpty: () => false,
	buttonTitle: null,
	isPromoPage: false,
	flexDirection: "column",
	justifyContent: "center",
	widthImage: "100%",
	textAlign: "center",
	buttonJustifyContent: "center",
	gap: "0px",
	buttonBorderRadius: "2px",
};

export default EmptyState;
